import { useQuery } from 'react-query';

import { getUserPaymentMethods } from '../controllers/get-user-payment-methods';
import { UserPaymentMethods } from '../models/user-payment-method';

/**
 * Gets the users payment methods, if they have any saved.
 */
export function useUserPaymentMethods() {
  return useQuery<UserPaymentMethods>('user-payment-method', getUserPaymentMethods);
}
